const options = {
  openClass: 'is--open',
  hiddenClass: 'is--hidden',
};

/**
 * @param  {HTMLElement} breadcrumb the breadcrumb to get the entries from
 * @return {Array} entries
 */
function getBreadcrumbEntries(breadcrumb) {
  return [].slice.call(breadcrumb.querySelectorAll('li'));
}

/**
 * @param  {HTMLElement} breadcrumb the breadcrumb to expand
 * @return {void}
 */
function expandBreadcrumb(breadcrumb) {
  const entries = getBreadcrumbEntries(breadcrumb);
  const closeButton = breadcrumb.querySelector('[data-close]');
  const expandElement = breadcrumb.querySelector('[data-expand]');

  // add open class
  breadcrumb.classList.add(options.openClass);

  // show hidden entries
  entries.forEach((entry) => {
    entry.classList.remove(options.hiddenClass);
  });

  // remove element to expand breadcrumb
  breadcrumb.querySelector('ul').removeChild(expandElement);

  // show close button and add event listener
  closeButton.classList.remove(options.hiddenClass);
}

/**
 * @param  {HTMLElement} breadcrumb the breadcrumb to create the element for
 * @return {HTMLElement} element for hidden entries
 */
function createElementForHiddenEntries(breadcrumb) {
  const entries = getBreadcrumbEntries(breadcrumb);
  const element = entries[0].cloneNode(false);
  const icon = breadcrumb.dataset.icon;

  // add classes and attributes
  element.classList.add('is--placeholder');
  element.dataset.expand = true;

  // add content
  element.innerHTML = `<span class="nav__item__trigger"><svg class="icon"><use xlink:href="${icon}"></use></svg><span>&hellip;</span></span>`;

  // event listener
  element.addEventListener('click', () => {
    expandBreadcrumb(breadcrumb);
  });

  // return
  return element;
}

/**
 * @param  {HTMLElement} breadcrumb the breadcrumb to collapse
 * @return {void}
 */
function collapseBreadcrumb(breadcrumb) {
  const threshold = breadcrumb.dataset.threshold || 3;
  const entries = getBreadcrumbEntries(breadcrumb);
  const numberOfEntries = entries.length;
  const expandElement = createElementForHiddenEntries(breadcrumb);
  const closeButton = breadcrumb.querySelector('[data-close]');

  if (numberOfEntries > threshold) {
    const entriesToHide = entries.slice(1, numberOfEntries - 1);

    // remove open class
    breadcrumb.classList.remove(options.openClass);

    // add class to hide entries
    entriesToHide.forEach((entry) => {
      entry.classList.add(options.hiddenClass);
    });

    // insert element to expand breadcrumb before last entry
    breadcrumb.querySelector('ul').insertBefore(expandElement, entries[entries.length - 1]);

    // hide close button
    closeButton.classList.add(options.hiddenClass);
  }
}

/**
 * start the magic
 *
 * @return {void}
 */
function init() {
  const breadcrumb = document.querySelector('[data-breadcrumb]');

  if (breadcrumb !== null) {
    const closeButton = breadcrumb.querySelector('[data-close]');

    // set initial state
    collapseBreadcrumb(breadcrumb);

    // event listener
    closeButton.addEventListener('click', () => {
      collapseBreadcrumb(breadcrumb);
    });
  }
}

init();



// WEBPACK FOOTER //
// ./assets/js/components/breadcrumb.js